var React = require('react');

function Ethereum (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#343434","d":"M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z","key":0}),React.createElement("path",{"fill":"#8C8C8C","d":"M127.962 0L0 212.32l127.962 75.639V154.158z","key":1}),React.createElement("path",{"fill":"#3C3C3B","d":"M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z","key":2}),React.createElement("path",{"fill":"#8C8C8C","d":"M127.962 416.905v-104.72L0 236.585z","key":3}),React.createElement("path",{"fill":"#141414","d":"M127.961 287.958l127.96-75.637-127.96-58.162z","key":4}),React.createElement("path",{"fill":"#393939","d":"M0 212.32l127.96 75.638v-133.8z","key":5})]);
}

Ethereum.defaultProps = {"width":"1535","height":"2500","viewBox":"0 0 256 417","preserveAspectRatio":"xMidYMid"};

module.exports = Ethereum;

Ethereum.default = Ethereum;
